import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="voucher-numpad"
export default class extends Controller {
  static targets = ["display"]

  connect() {
    this.value = "0"
    this.updateDisplay()

    // 바우처 유형 select 변경 시 전체 리셋
    this.voucherRadios = document.querySelectorAll('input[name="voucher"]')
    if (this.voucherRadios.length) {
      this.boundOnVoucherChange = this.onVoucherChange.bind(this)
      this.voucherRadios.forEach(el =>
          el.addEventListener("change", this.boundOnVoucherChange)
      )
    }

    console.log("Voucher numpad controller connected")
  }

  disconnect() {
    if (this.voucherRadios && this.boundOnVoucherChange) {
      this.voucherRadios.forEach(el =>
          el.removeEventListener("change", this.boundOnVoucherChange)
      )
    }
  }

  onVoucherChange() {
    const selected = event.target

    const voucherPriceIdInput = document.getElementById("voucher_price_id")
    if (voucherPriceIdInput && selected) {
      voucherPriceIdInput.value = selected.value
    }
    this.resetAll()
  }

  resetAll() {
    // numpad 값 리셋
    this.value = "0"
    this.updateDisplay()

    // 결제 버튼 잠금
    const submitButton = document.querySelector(
        'form[data-turbo-frame="modals"] input[type="submit"]'
    )
    if (submitButton) submitButton.classList.add("disabled")

    // hidden 값도 명시적으로 0 처리
    const voucherCountInput = document.getElementById("voucher_count")
    const priceInput = document.getElementById("price")
    if (voucherCountInput) voucherCountInput.value = "0"
    if (priceInput) priceInput.value = "0"
  }

  press(event) {
    const key = event.currentTarget.dataset.key

    let next
    if (this.value === "0") {
      next = key
    } else if (this.value.length < 10) {
      next = this.value + key
    } else {
      return
    }

    this.value = next
    this.updateDisplay()
  }

  clear() {
    this.value = "0"
    this.updateDisplay()
  }

  updateDisplay() {
    try {
      // 숫자 계산용(콤마 없는 정수)
      const countNumber = parseInt(this.value || "0", 10) || 0
      const countText = countNumber.toLocaleString("ko-KR")

      // 화면 표시(수량)
      this.displayTarget.textContent = countText

      const summaryCount = document.getElementById("summary-count")
      if (summaryCount) summaryCount.textContent = countText

      // 선택된 바우처 가격(숫자)
      const selected = document.querySelector('input[name="voucher"]:checked')
      const priceNumber = Number(selected?.dataset.price || 0)

      // 합계
      const total = countNumber * priceNumber
      const totalText = total.toLocaleString("ko-KR")

      const summaryTotalPrice = document.getElementById("summary-total-price")
      if (summaryTotalPrice) summaryTotalPrice.textContent = totalText

      const summaryPrice = document.getElementById("summary-price")
      if (summaryPrice) summaryPrice.textContent = totalText

      // hidden 필드
      const voucherCountInput = document.getElementById("voucher_count")
      const priceInput = document.getElementById("price")
      if (voucherCountInput) voucherCountInput.value = String(countNumber)
      if (priceInput) priceInput.value = String(total)

      // 버튼 활성/비활성
      const submitButton = document.querySelector(
          'form[data-turbo-frame="modals"] input[type="submit"]'
      )
      if (submitButton) {
        const selected = document.querySelector('input[name="voucher"]:checked')

        if (countNumber > 0 && selected) {
          submitButton.classList.remove("disabled")
        } else {
          submitButton.classList.add("disabled")
        }
      }
    } catch (e) {
      console.error("Error updating display:", e)
      this.displayTarget.textContent = "0"
      this.value = "0"
    }
  }
}
